module.exports = __webpack_public_path__ + "img/MO.362bb6cb.svg";